<template>
  <div class="navbar-wrapper">
    <div class="navbar container">
      <div class="navbar-logo">
        <img src="@/assets/ej-logo.png" />
        <p>EyeJack Traitz</p>
      </div>
      <div class="navbar-links">
        <a href="#features" v-smooth-scroll>Features</a>
        <a href="#EOI" v-smooth-scroll>EOI</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
};
</script>

<style lang="scss" scoped>
@import "@/styles/styles.scss";
.navbar-wrapper {
  .navbar {
    display: flex;
    background: #000;
    flex-direction: row;
    justify-content: space-between;
    height: 80px;
    &-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 3%;
        margin-left: 10px;
        color: white;
        @include media(">=tablet") {
          margin-left: 15px;
          font-size: 16px;
        }
      }
      img {
        width: 65px;
        // height: 35px;
        height: auto;
        @include media(">=tablet") {
          width: 80px;
          // height: 45px;
        }
      }
    }
    &-links {
      display: flex;
      justify-content: center;
      align-items: center;
      a {
        margin-left: 22px;
        letter-spacing: 1.55px;
        padding-bottom: 3px;
        font-size: 14px;
        @include media(">=tablet") {
          margin-left: 55px;
          font-size: 16px;
        }
      }
      a:hover {
        border-bottom: 1px solid #fff;
      }
    }
  }
}
</style>
